import { defineStyle, defineStyleConfig } from '@chakra-ui/styled-system';

const baseStyle = defineStyle({
  color: 'black',
  fontFamily: 'heading',
  fontWeight: 500,
  letterSpacing: '-1px',
});

const sizes = {
  '5xl': defineStyle({
    fontSize: { mobile: '72px', desktop: '84px' },
    lineHeight: { mobile: 1, desktop: 1 },
  }),
  '4xl': defineStyle({
    fontSize: { mobile: '60px', desktop: '72px' },
    lineHeight: { mobile: 1, desktop: 1 },
  }),
  '3xl': defineStyle({
    fontSize: { mobile: '48px', desktop: '60px' },
    lineHeight: { mobile: 1, desktop: 1 },
  }),
  '2xl': defineStyle({
    fontSize: { mobile: '36px', desktop: '48px' },
    lineHeight: { mobile: 1.2, desktop: 1 },
  }),
  xl: defineStyle({
    fontSize: { mobile: '30px', desktop: '36px' },
    lineHeight: { mobile: 1.33, desktop: 1 },
  }),
  lg: defineStyle({
    fontSize: { mobile: '24', desktop: '30px' },
    lineHeight: { mobile: 1.33, desktop: 1.2 },
  }),
  md: defineStyle({
    fontSize: { mobile: '24px', desktop: '24px' },
    lineHeight: { mobile: 1.2 },
  }),
  sm: defineStyle({
    fontSize: { mobile: '20px' },
    lineHeight: { mobile: 1.2 },
  }),
  xs: defineStyle({
    fontSize: { mobile: '16px' },
    lineHeight: { mobile: 1.2 },
  }),
};

export const Heading = defineStyleConfig({
  baseStyle,
  sizes,
  defaultProps: {
    size: 'xl',
  },
});
